import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-msg-create',
  templateUrl: './msg-create.component.html',
  styleUrls: ['./msg-create.component.css']
})
export class MsgCreateComponent implements OnInit {
    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {

    }

    private async loadEdit() {
        this.edit = (await this.datatask.Post(1683))[0];
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1684, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService?.go('translateedit', { item_id: this.edit?.word_id });
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    word_id: string;
    language_id: string;
    wordlang_name: string;
    proc_call_syntax: string;
}
